import React, { Component } from 'react';

const firebase = require('firebase')
const firebaseui = require('firebaseui')

class FirebaseUILogin extends Component {
    constructor(props) {
      super(props)
    }
  
    componentDidMount() {
        // Initialize the FirebaseUI Widget using Firebase.
        const ui = new firebaseui.auth.AuthUI(firebase.auth())

        const uiConfig = {
            callbacks: {
                signInSuccessWithAuthResult: function(authResult, redirectUrl) {
                // User successfully signed in.
                // Return type determines whether we continue the redirect automatically
                // or whether we leave that to developer to handle.
                // return true;
                return false;
                },
                uiShown: function() {
                // The widget is rendered.
                // Hide the loader.
                document.getElementById('loader').style.display = 'none';
                }
            },
            // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
            signInFlow: 'popup',
            // signInSuccessUrl: '/',
            signInOptions: [
                // Leave the lines as is for the providers you want to offer your users.
                firebase.auth.FacebookAuthProvider.PROVIDER_ID,
                // firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                // firebase.auth.TwitterAuthProvider.PROVIDER_ID,
                // firebase.auth.GithubAuthProvider.PROVIDER_ID,
                // firebase.auth.EmailAuthProvider.PROVIDER_ID,
                // firebase.auth.PhoneAuthProvider.PROVIDER_ID
            ],
            // Terms of service url.
            // tosUrl: '<your-tos-url>'
        }
        
        // The start method will wait until the DOM is loaded.
        ui.start('#firebaseui-auth-container', uiConfig)
    }

    componentWillUnmount() {
        const ui = firebaseui.auth.AuthUI.getInstance()
        ui.delete()
    }

  
    render() {
      const { fullScreen, isLoginDialogOpen, toggleLoginDialog } = this.props
      
      return (
        <div>
            {/* <h1>Welcome to My Awesome App</h1> */}
            <div id="firebaseui-auth-container"></div>
            <div id="loader">Loading...</div>
        </div>
      )
    }
}

export default FirebaseUILogin;


// WEBPACK FOOTER //
// ./src/components/FirebaseUILogin.js